export const BOOTSTRAP_CURRENCIES = 'BOOTSTRAP_CURRENCIES'
export const SET_DEFAULT_CURRENCY = 'SET_DEFAULT_CURRENCY'
export const ADD_CURRENCY = 'ADD_CURRENCY'
export const UPDATE_CURRENCY = 'UPDATE_CURRENCY'
export const DELETE_CURRENCY = 'DELETE_CURRENCY'
